import type { WorkspaceEntityStore, WorkspaceRuntime } from '#layers/runtime/public';
import { effectScope } from 'vue';
import { createWorkspaceFetch } from '#layers/base/public';
import { createWorkspaceOperationTracker } from '#layers/runtime/public';
import { createWorkspaceRStore } from '~/rstore/create-workspace-rstore';

declare module '#layers/runtime/entity-store/registry' {
	interface WorkspaceEntityStoreRegistry {
		store: Awaited<ReturnType<typeof createWorkspaceRStore>>;
	}
}

let nextRuntimeIdentity = 0;

interface CreateWorkspaceRuntimeOptions {
	baseURL: string;
	slug: string;
}

/** One transport serves the store's plugin CRUD, custom collection fetches, and `runtime.fetch`; the identity keys workspace-derived UI. */
export async function createWorkspaceRuntime({ baseURL, slug }: CreateWorkspaceRuntimeOptions): Promise<WorkspaceRuntime<WorkspaceEntityStore>> {
	const abortController = new AbortController();
	const fetch = createWorkspaceFetch({ baseURL, runtimeSignal: abortController.signal });

	try {
		const store = await createWorkspaceRStore(fetch);

		return {
			abortController,
			fetch,
			identity: `${slug}:${++nextRuntimeIdentity}`,
			operations: createWorkspaceOperationTracker(),
			scope: effectScope(true),
			slug,
			store,
		};
	}
	catch (error) {
		abortController.abort();
		throw error;
	}
}
